import styled from 'styled-components'

const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  overflow: hidden;
  margin-bottom: ${props => {
    if (props.removeMargin) return 0
    if (props.smallMargin) return '16px'
    return '24px'
  }};
`

export { PriceContainer }
